/**
 * Maps a series label (e.g. "Pending", "Approved", "Open") to a semantic
 * token. Falls back to a categorical ramp for dynamic / unknown labels.
 */

const readToken = (name, fallback) => {
  if (typeof window === "undefined") return fallback;
  const v = getComputedStyle(document.documentElement)
    .getPropertyValue(name)
    .trim();
  return v || fallback;
};

const CATEGORICAL = [
  "--rdc-cat-1",
  "--rdc-cat-2",
  "--rdc-cat-3",
  "--rdc-cat-4",
  "--rdc-cat-5",
  "--rdc-cat-6",
  "--rdc-cat-7",
  "--rdc-cat-8",
];

const ROLE_MAP = {
  // success-ish
  approved: "--rdc-success",
  active: "--rdc-success",
  completed: "--rdc-success",
  closed: "--rdc-success",
  collected: "--rdc-success",
  // warning-ish
  pending: "--rdc-warning",
  // danger-ish
  denied: "--rdc-danger",
  rejected: "--rdc-danger",
  inactive: "--rdc-danger",
  canceled: "--rdc-danger",
  cancelled: "--rdc-danger",
  // brand-ish (in-flight)
  open: "--rdc-brand-500",
  inprogress: "--rdc-brand-500",
  "in progress": "--rdc-brand-500",
  // info-ish
  booked: "--rdc-info",
  follow_up: "--rdc-info",
  "follow up": "--rdc-info",
  "follow-up": "--rdc-info",
};

const normalize = (label) =>
  String(label || "")
    .trim()
    .toLowerCase()
    .replace(/[_-]+/g, "_");

export const colorForLabel = (label, fallbackIndex = 0) => {
  const key = normalize(label);
  const tokenRole = ROLE_MAP[key] || ROLE_MAP[key.replace(/_/g, " ")];
  if (tokenRole) return readToken(tokenRole, "#0e578e");
  const tokenCat = CATEGORICAL[fallbackIndex % CATEGORICAL.length];
  return readToken(tokenCat, "#0e578e");
};

export const buildSeriesColors = (labels) =>
  labels.map((label, i) => ({ label, color: colorForLabel(label, i) }));
